import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from 'src/app/session-service.service';
import { SessionOrvService } from '../../services/session-orv.service';
import { openBlob } from '../../utils/utils';
import { ApplicationApiService } from '../../services/applicationApiService';

@Component({
  selector: 'app-application-thank-you',
  templateUrl: './application-thank-you.component.html',
  styleUrls: ['./application-thank-you.component.css']
})
export class ApplicationThankYouComponent implements OnInit {
  @Input()
  firstParagraph = '';
  @Input()
  subTitle = '';
  @Input()
  secondParagraph = '';
  @Input()
  thirdParagraph = '';
  @Input()
  fourthParagraph = '';
  @Input()
  downloadPdf = '';
  @Output()
  resetApplication = new EventEmitter();

  transactionId: string;
  showStartIdentificationPage = false;

  constructor(
    private sessionService: SessionService,
    private sessionOrvService: SessionOrvService,
    private applicationApiService: ApplicationApiService,
  ) {
    this.transactionId = localStorage.getItem('trxid');
  }

  ngOnInit(): void {
    this.resetApplication.emit();
  }

  get isOneInsured(): boolean {
    return this.sessionService.getSecondInsured() === null;
  }

  openReceiptPDF(e): void {
    e.preventDefault();
    this.applicationApiService.getReceiptPDF(this.transactionId)
      .subscribe(response => {
        openBlob(response, 'Receipt.pdf');
      });
  }
}
